import { IssueModel } from 'shared/domain/issue/issueModel';
import { ReactElement, useMemo } from 'react';
import { useProcesses } from 'store/process';
import { SelectablePin } from '../../location/pin/SelectablePin';
import { PinType, ProcessColors } from './types';

export function IssuePins({
  issues,
  processesWithPositionOnMap,
}: {
  issues: IssueModel[];
  processesWithPositionOnMap: string[];
}): ReactElement {
  const { processes } = useProcesses();
  const colors: ProcessColors = useMemo(() => {
    return processes.reduce((result: ProcessColors, process) => {
      result[process._id] = process.color;
      return result;
    }, {});
  }, [processes]);

  const pins: PinType[] = useMemo(
    () => issuesToPins(issues, colors, processesWithPositionOnMap),
    [issues, colors, processesWithPositionOnMap]
  );

  return (
    <>
      {pins.map((pin) => {
        return (
          <SelectablePin
            key={pin.key}
            x={pin.x}
            y={pin.y}
            color={pin.color}
            _id={pin.key}
            tooltip={pin.tooltip}
            addIndexMarker={true}
          />
        );
      })}
    </>
  );
}

function issuesToPins(
  issues: IssueModel[],
  colors: ProcessColors,
  processesWithPositionOnMap: string[]
): PinType[] {
  return issues.reduce((result: PinType[], issue: IssueModel) => {
    const position = issue.primaryData.location?.positionOnMap;
    // Only a pinned issue has a position: the backend sets no default pin (PT-7117).
    if (!position || !processesWithPositionOnMap.includes(issue.process)) {
      return result;
    }
    const { x, y } = position;
    result.push({
      x,
      y,
      key: issue._id,
      color: colors[issue.process],
      tooltip: issue.primaryData.title,
    });
    return result;
  }, []);
}
